import { Tag } from 'antd';
import type { ReadinessItem } from '../dispatch.api';

function stateOf(item: ReadinessItem): { colour: string; text: string } {
  if (item.met) return { colour: 'success', text: 'Done' };
  if (item.overridden) return { colour: 'warning', text: 'Overridden' };
  return { colour: 'error', text: 'Outstanding' };
}

/** The job's readiness checklist. An outstanding item stops the dispatch until it is done or a supervisor overrides it on the job. */
export function DispatchReadiness({ items }: { items: ReadinessItem[] }) {
  return (
    <section aria-label="Job readiness" className="rounded-lg border border-line bg-surface p-5">
      <h2 className="mb-3 text-base font-semibold text-fg">Job readiness</h2>
      <ul className="flex flex-col gap-2 text-sm">
        {items.map((item) => {
          const state = stateOf(item);
          return (
            <li key={item.key} className="flex items-center justify-between gap-3">
              <span className="text-fg">{item.label}</span>
              <Tag color={state.colour}>{state.text}</Tag>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
